export const getDeviceId = () => {
  const DEVICE_ID_KEY = 'deviceId';
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = `device-${crypto.randomUUID()}`;
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
};

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
